
import Vue from "vue";
import {eventBus, vm} from "@/main";
import store from '@/store';
import axios from "axios";
import Api from "./Api";
import  axiosApi from "./axios";

import { loadScript } from "vue-plugin-load-script";
import bridge from "@vkontakte/vk-bridge";



export default class UserModel {
    static  setAuthHeader(token){
        axiosApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    static parseGetRedirect(current_app){
        var paramsString_Arr=document.location.href.split('?');
         if(paramsString_Arr && paramsString_Arr[1]){

            let paramString = paramsString_Arr[1].split("#")[0];

            let queryString = new URLSearchParams(paramString);
             var tgWebAppStartParam=queryString.get('tgWebAppStartParam');





            if(current_app.$route && tgWebAppStartParam){
                var need_url=tgWebAppStartParam;
                need_url=need_url.replaceAll("s1s","/");
                 if(current_app.$route.path!=need_url){

                    current_app.$router.push(need_url);
                }
             }
        }
    }
    static unsetAuthHeader() {

        delete axiosApi.defaults.headers.common['Authorization'];
    }

    static get(){



        if(store.getters.USER){
            return store.getters.USER;
        }else if(localStorage.getItem('user')!=null && localStorage.getItem('user').length){
            return  JSON.parse(localStorage.getItem('user'));
        }

        return null;
    }
    static async isIframeVK(){
        try {
            var data_launch = await bridge.send('VKWebAppGetLaunchParams');

            if (data_launch.vk_app_id) {
                return true;
            }
        }
        catch(err){
            return false;
        }

        return false;
    }

    static async getWithUpdate(){
        var user=UserModel.get();

        var data = await Api.loadUserByToken(user.api_token);

        if(data && data.api_token) {
            UserModel.set(data, false);


            return data;
        }
    }
    static getGlobalHash(){
        if ((window.location.hash && window.location.hash.length > 0 && window.location.hash.includes('tgWebAppData'))){
            return window.location.hash;
        }else {
            return "222";
        }
    }
    static checkIsWebApp(){
        if(window &&    window.Telegram &&  window.Telegram.WebApp && window.Telegram.WebApp.platform && window.Telegram.WebApp.platform!="unknown" && window.Telegram.WebApp.colorScheme){
            return true;
        }else {
            return false;
        }
    }
    static isTWA(){
        if(localStorage.getItem('isPWA')){
            var value=localStorage.getItem('isPWA');
            if(value=='true'){
                return true;
            }

        }else {
            return false;
        }
    }
    static async need_check(){

        try {


            const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });
            if(params.code){

                var data = await Api.loadUserByOneCode(params.code);

                if(data && data.api_token) {
                    UserModel.set(data, false);
                    window.location.replace(location.pathname);

                    return Promise.resolve(true);
                }
            }
            if(params && params.api){

                var data = await Api.loadUserByToken(params.api);
                if(data && data.api_token) {
                    UserModel.set(data, false);
                    window.location.replace(location.pathname);

                    return Promise.resolve(true);
                }
            }




            // if (window.location.hash && window.location.hash.length > 0 && window.location.hash.includes('tgWebAppData')) {
            //
            //
            //     // http://localhost:8080/redirect?redirect_inner=home#tgWebAppData=query_id%3DAAEX3xULAAAAABffFQsNA_6u%26user%3D%257B%2522id%2522%253A185982743%252C%2522first_name%2522%253A%2522Artem%2522%252C%2522last_name%2522%253A%2522Phpcoder%2522%252C%2522username%2522%253A%2522artemphp%2522%252C%2522language_code%2522%253A%2522ru%2522%257D%26auth_date%3D1650820242%26hash%3D8c2dd522b9b18cd6a6bd9e4aff22e8e37e68cca0744923aca9e04f07f08c603e&tgWebAppThemeParams=%7B%22bg_color%22%3A%22%23ffffff%22%2C%22button_color%22%3A%22%2340a7e3%22%2C%22button_text_color%22%3A%22%23ffffff%22%2C%22hint_color%22%3A%22%23999999%22%2C%22link_color%22%3A%22%23168acd%22%2C%22text_color%22%3A%22%23000000%22%7D
            //
            //     await loadScript("https://telegram.org/js/telegram-web-app.js");
             //     if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) {
            //
            //         window.Telegram.WebApp.ready();
            //         var theme_mode="day_mode";
            //         if(window && window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.colorScheme=="dark"){
            //             theme_mode="night_mode";
            //         }
            //         eventBus.$emit("set_name_theme",{"theme":theme_mode})

            //

            //
            //            UserModel.set(data.user,false);
            //            localStorage.setItem("isPWA",true);
            //            return Promise.resolve(true);
            //         },function(){
            //            return  Promise.resolve(false);
            //         });
            //
            //
            //     }
            //
            //
            // } else
            if (store.getters.USER != null) {
                UserModel.set(store.getters.USER);
                return Promise.resolve(true);

            } else if (localStorage.getItem('user') != null && localStorage.getItem('user').length > 0) {
                UserModel.set(JSON.parse(localStorage.getItem('user')));
                return Promise.resolve(true);
            } else if (localStorage.getItem('api_token') != null) {


                var data = await Api.loadUserByToken(localStorage.getItem('api_token'));
                return Promise.resolve(true);





            }
        }catch (e){


        }

        return Promise.resolve(false);

    }
    static async loginVk(){

        var data_launch=  await bridge.send('VKWebAppGetLaunchParams');
        var data_auth=await bridge.send('VKWebAppGetAuthToken', {
            app_id: data_launch.vk_app_id,
            scope: 'friends,status'
        });
        Api.checkVkIframeAuth(data.access_token,function(data){

        });

    }
    static async checkActivate(){
        try {

            var result=await UserModel.need_check();

            if(result==true){

                var user_data=UserModel.get();

              if(user_data && user_data.api_token){
                  var new_user_data=await Api.loadUserByToken(user_data.api_token);

                  if(new_user_data && new_user_data.is_activate==1){
                      return   Promise.resolve(2);
                  }else {
                      return Promise.resolve(1);
                  }
              }

            }

            return Promise.resolve(0);




        } catch (err) {


            return   Promise.resolve(0);
            // обработка ошибки

        }
    }
    static async check(){



        try {

            var result=await UserModel.need_check();
            return   Promise.resolve(result);
        } catch (err) {

            return   Promise.resolve(false);
            // обработка ошибки

        }















    }

    static async set_wait(user){
        UserModel.setAuthHeader(user.api_token);
        localStorage.setItem('api_token', user.api_token);

        localStorage.setItem('user',JSON.stringify(user));
        store.commit('SET_ISAUTH', true);

        store.commit('SET_USER', user);
        store.commit('SET_TOKEN',user.api_token);

        if (user.isdeveloper == 1) {

            store.commit('SET_ISDEVELOPER', true);
        } else {
            store.commit('SET_ISDEVELOPER', false);
        }


        //  eventBus.$emit('user_is_login', user);







        Promise.resolve(user);
    }
    static set(user){
        localStorage.setItem('api_token', user.api_token);

        localStorage.setItem('user',JSON.stringify(user));
        UserModel.setAuthHeader(user.api_token);

        store.commit('SET_ISAUTH', true);

        store.commit('SET_USER', user);
        store.commit('SET_TOKEN',user.api_token);

        if (user.isdeveloper == 1) {

            store.commit('SET_ISDEVELOPER', true);
        } else {
            store.commit('SET_ISDEVELOPER', false);
        }


        //  eventBus.$emit('user_is_login', user);





        eventBus.$emit("update_mainbar",{"user":user,"islogin":true});
        //
        //eventBus.$emit('update_user_info', store.getters.ISAUTH, store.getters.ISDEVELOPER);

    }
    static logout(){
        if(localStorage.getItem('api_token')!=null){
            localStorage.removeItem('api_token');
        }
        if(localStorage.getItem('user')){
            localStorage.removeItem('user');
        }
       var  tg_inside_init_data=null;
        if(localStorage.getItem('tg_inside_init_data')){
            tg_inside_init_data=localStorage.getItem('tg_inside_init_data');
        }
       // localStorage.clear();

        UserModel.unsetAuthHeader();
        store.commit('SET_TOKEN', null);
        store.commit('SET_ISAUTH', false);
        store.commit('SET_USER', null);
        if(tg_inside_init_data){
            //localStorage.setItem('tg_inside_init_data',tg_inside_init_data);
        }
        eventBus.$emit("update_mainbar",{"user":{},"islogin":false});


    }
}
